import Auth from "./Auth"
import Data from "./Data"

// eslint-disable-next-line
export default {
	Auth,
	Data
}
